import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * /pricing is a commonly guessed URL. Send visitors to the membership page
 * rather than showing a 404.
 */
export const Route = createFileRoute("/pricing")({
  beforeLoad: () => {
    throw redirect({ to: "/membership" });
  },
});
